import React from 'react';
const FormLessForm = (props) => {
  const getActionURL = () => {
    const hiddenFields = `utm_campaign=AO_NA_US_LE-ABM_BRC-GYB-Best-Practices-Ebook-Formless-LP&utm_source=Pardot&utm_medium=Email&utm_content=BRC-Formless-Email&email=${props.pdtmail}`;
    const urlKey = `${props.country}|${props.locale}|${props.slugId}`;
    return props.pdtmail === "" ? "https://www.paypalobjects.com/ecm_assets/PayPal-Enterprise-Checkout-eBook-Final[51].pdf" :
      `${handlerURL[urlKey]}?${hiddenFields}`;
  }
  const handlerURL = {
    "us|en_US|enterprise-solutions-reimagine-customer-checkout": "https://pypd.paypal-mktg.com/l/925803/2021-10-20/2gjfn",
  }
  return (
    <div className="button-container" style={{"width":"100%","text-align":"center","margin":"30px 10px 10px 10px"}}>
      <a href={getActionURL()}
         style={{"display": "inline", "padding": "13px 80px","color":"#ffffff" }}
         target="_blank"
         pa-marked="1"
         data-pa-click={"buttonClick|" + props.slugId}
         className="pdf-download-btn pypl-btn" >
        Download
      </a>
    </div>
  );
};

export default FormLessForm;
